import React, { useState } from "react";
import { Gift, Loader2, TrendingUp } from "lucide-react";
import { formatCash } from "../../utils/operatorConsoleHelpers";
import { formatRelative } from "../../utils/bettorsDeskHelpers";
import BettorRewardModal from "./BettorRewardModal";
import TicketTape from "./TicketTape";

const BettorDetailPanel = ({
  bettor,
  tickets,
  ticketsLoading,
  ticketsError,
  houseId,
  houseName,
  operatorUserId,
  onRewardSuccess,
}) => {
  const [rewardOpen, setRewardOpen] = useState(false);
  const [rewardSubmitting, setRewardSubmitting] = useState(false);

  if (!bettor) {
    return (
      <aside className="bd-detail bd-detail-empty">
        <div className="bd-detail-placeholder">
          <TrendingUp size={28} strokeWidth={1.5} />
          <strong>Select a bettor</strong>
          <p>Pick someone from the roster to inspect their ticket tape and staking profile.</p>
        </div>
      </aside>
    );
  }

  const isRepeat = Number(bettor.ticketCount || 0) >= 2;
  const canReward = !!(houseId && operatorUserId && bettor.userId);

  return (
    <aside className="bd-detail">
      <header className="bd-detail-head">
        <div className="bd-detail-avatar">{bettor.username?.[0]?.toUpperCase() || "?"}</div>
        <div>
          <h2>{bettor.username || "Bettor"}</h2>
          <p>Last bet {formatRelative(bettor.lastBetAt)}</p>
        </div>
        <span className={`bd-tag ${isRepeat ? "bd-tag-repeat" : ""}`}>
          {isRepeat ? "Repeat" : "Bettor"}
        </span>
      </header>

      <div className="bd-detail-stats">
        <div>
          <em>Tickets</em>
          <strong>{bettor.ticketCount ?? 0}</strong>
        </div>
        <div>
          <em>Total staked</em>
          <strong className="tabular-nums">{formatCash(bettor.totalStaked, { compact: true })}</strong>
        </div>
        <div>
          <em>Avg stake</em>
          <strong className="tabular-nums">
            {formatCash(
              (Number(bettor.totalStaked) || 0) / Math.max(1, Number(bettor.ticketCount) || 1),
              { compact: true }
            )}
          </strong>
        </div>
      </div>

      <button
        type="button"
        className={`bd-reward-btn ${rewardSubmitting ? "bd-reward-btn-loading" : ""}`}
        disabled={!canReward || rewardSubmitting}
        onClick={() => setRewardOpen(true)}
        title={canReward ? "Send Cash or Coins to this bettor" : "Sign in to send rewards"}
      >
        {rewardSubmitting ? (
          <>
            <Loader2 size={14} className="bd-reward-btn-spin" aria-hidden />
            Sending…
          </>
        ) : (
          <>
            <Gift size={14} />
            Send reward
          </>
        )}
      </button>

      <TicketTape
        tickets={tickets}
        loading={ticketsLoading}
        error={ticketsError}
      />

      <BettorRewardModal
        open={rewardOpen}
        onClose={() => {
          setRewardOpen(false);
          setRewardSubmitting(false);
        }}
        houseId={houseId}
        houseName={houseName}
        bettor={bettor}
        operatorUserId={operatorUserId}
        onSuccess={onRewardSuccess}
        onSubmittingChange={setRewardSubmitting}
      />
    </aside>
  );
};

export default BettorDetailPanel;
